import Loadable from 'react-loadable';

import LoadableLoading from 'components/LoadableLoading';

export const path = '/chrona/objects/:guid';

export const getPath = (guid: string) => `/chrona/objects/${guid}`;

// Роут-левел код-сплит: сама страница грузит данные (объект + должности) по :guid.
const PageChronaGeoZoneEditor = Loadable({
  loader: () => import('./page'),
  loading: LoadableLoading,
});

export default PageChronaGeoZoneEditor;
